import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClassicTable } from "../clientMaster/ClassicTable";
import { Autocomplete, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DateInput, TextFields } from "../../../utils/Custom/custominput";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { fetchAddresses, fetchQuery } from "../../../utils/commonComponent/fetched";
import { BASE_URL, reportLetter } from "../../../global";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import moment from "moment";
import { format } from "date-fns";
import { clienTypes } from "../../../utils/commonComponent/common";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";
import { statesList } from "../../constants/stateList";
import { getPermissions } from "../rbac/hasAccess";

const inspectionservicesTable = [
  { field: "id", headerName: "Sr.No." },
  { field: "inspectionservicesTable", headerName: "Items" },
  { field: "quantity", headerName: "Quantity" },
  { field: "clientRequestFile", headerName: "Inspection Call/PO" },
  { field: "qapDrawings", headerName: "QAP" },
  { field: "technicalDatasheet", headerName: "Drawing/Datasheet" },
  { field: "technicalSpecification", headerName: "Technical Specification" },
];

const UploadButton = ({
  label = "Upload",
  onChange,
  outline = false,
  className = "",
  ...props
}) => {
  const baseClasses =
    "btn font-sans text-sm font-medium py-2 px-3 rounded inline-flex items-center justify-center gap-2 cursor-pointer";
  const colorClasses = outline
    ? "text-indigo-600 border border-indigo-600 hover:bg-gray-100"
    : "text-white bg-indigo-600 hover:bg-indigo-700";

  return (
    <label className={`${baseClasses} ${colorClasses} ${className}`}>
      <CloudUploadIcon fontSize="small" />
      {label}
      <input
        type="file"
        multiple
        onChange={onChange}
        className="hidden"
        {...props}
      />
    </label>
  );
};
const FileUploadComponent = ({
  fileUploadResponse = "",
  setFileUploadResponse,
  label,
}) => {
  const [open, setOpen] = React.useState(false);

  const files = fileUploadResponse
    ? fileUploadResponse.split(",")
    : [];

  const handleFileUpload = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    // Temporary URL for testing (will be replaced with actual upload)
    // const tempUrl = "https://DYC Global.bfiinfotech.co.in/api/fileUpload/uploads/1766488710__LIMS%20%202%20Plans.pdf";

    const uploadedUrls = [];

    for (const file of selectedFiles) {
      // Comment out the actual upload code
      // uploadedUrls.push(tempUrl);

      const data = new FormData();
      data.append("fileToUpload", file);

      try {
        const res = await axiosWithToken.post(BASE_URL + "fileUpload/fileUpload.php", data);
        if (res.status === 200) {
          uploadedUrls.push(res.data);
        }
      } catch (err) {
        console.error(err);
      }
    }

    const existing = fileUploadResponse
      ? fileUploadResponse.split(",")
      : [];

    setFileUploadResponse([...existing, ...uploadedUrls].join(","));
    toast.success("Files uploaded successfully!");
  };

  const handleRemoveFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFileUploadResponse(updated.join(","));
  };

  return (
    <div className="flex items-center gap-3">
      {/* View Button */}
      {files.length > 0 && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-blue-600 underline text-sm"
        >
          View ({files.length})
        </button>
      )}

      {/* Upload Button */}
      <UploadButton
        label={label}
        onChange={handleFileUpload}
        multiple
        className="!py-1 !px-2"
      />

      {/* Modal */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle className="flex justify-between items-center">
          Uploaded Files
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {files.length === 0 ? (
            <p className="text-sm text-gray-500">No files uploaded</p>
          ) : (
            <div className="flex flex-col gap-2">
              {files.map((url, index) => {
                const fileName = decodeURIComponent(
                  url.split("__").pop()
                );

                return (
                  <div
                    key={index}
                    className="flex items-center justify-between border rounded px-3 py-2 text-sm"
                  >
                    <span className="truncate max-w-[250px]">
                      {fileName}
                    </span>

                    <div className="flex items-center gap-2">
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium"
                      >
                        View
                      </a>

                      <span className="text-gray-300">|</span>

                      <button
                        type="button"
                        onClick={() => handleRemoveFile(index)}
                        className="inline-flex items-center gap-1 text-red-500 hover:text-red-700 text-sm font-medium"
                      >
                        Remove
                      </button>
                    </div>

                  </div>
                );
              })}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
const quantityUnits = ["mm", "cm", "m", "µm", "No", "Set", "Ton", "Pair"];

const EditJobRegister = (props) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const navState = location.state || {};
  const [inputStates, setInputStates] = React.useState({});
  const [clientList, setClientList] = React.useState([]);
  const [poList, setPoList] = React.useState([{ id: 0, poNumber: "Verbal" }]);
  const [inspectionRows, setInspectionRows] = React.useState([]);
  const [inspectionItemsList, setinspectionItemsList] = React.useState([]);
  const [deletedInspectionIds, setDeletedInspectionIds] = React.useState([]);
  const [originalInspectionRows, setOriginalInspectionRows] = React.useState([]);
  const [districtOptions, setDistrictOptions] = React.useState([]);

  // New state for address management
  const [availableAddresses, setAvailableAddresses] = React.useState([]);
  const [showAddressSelection, setShowAddressSelection] = React.useState(false);

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const addRangeRow = () => {
    const newRow = {
      id: null, // Database ID (null for new rows)
      servicesNameId: "", // Selected service ID
      inspectionNumber: "", // Will be generated on save
      quantity: "",
      quantityUnit: "", // Unit for quantity
      clientRequestFile: "", // File upload for client request
      qapDrawings: "", // File upload for gap drawings
      technicalDatasheet: "", // File upload for technical datasheet
      technicalSpecification: "", // File upload for technical specification
      isNew: true, // Flag to identify new rows
    };
    setInspectionRows([...inspectionRows, newRow]);
  };
  // copy row
  const handleCopyRow = (index) => {
    const rowToCopy = inspectionRows[index];
    const count = parseInt(rowToCopy?.copyCount || "0", 10);
    if (!count || count < 1) return;

    const newRows = [...inspectionRows];
    const cleanRow = { ...rowToCopy, isNew: true };
    delete cleanRow.id;
    delete cleanRow.copyCount;

    const copies = Array(count)
      .fill(0)
      .map(() => ({ ...cleanRow }));

    newRows.splice(index + 1, 0, ...copies);
    setInspectionRows(newRows);
  };

  const fetchJobRegisterDetails = async () => {
    const [jobRegistration] = await fetchQuery(
      `select * from jobRegister where id = ${params.id}`
    );
    let poNumberID =
      poList.find((item) => item.poNumber == jobRegistration?.poNumber)?.id ||
      0;

    // Fetch address using the stored addressId
    const addressId = jobRegistration?.address;
    let addressText = "";
    if (addressId) {
      const addresses = await fetchAddresses(addressId);
      addressText = addresses[0]?.address || "";
    }
    setInputStates({
      ...jobRegistration,
      address: addressText,
      addressid: addressId,
      poNumberID,
    });
  };

  // Updated: Update cell value with file upload support
  const updateCellValue = (rowIndex, field, value) => {
    const newRows = [...inspectionRows];
    if (field === "servicesNameId") {
      // Find the selected service to get the name
      const selectedService = inspectionItemsList.find(
        (item) => item.id === value
      );
      newRows[rowIndex] = {
        ...newRows[rowIndex],
        servicesNameId: value,
        // items: selectedService?.items || ""
      };
    } else {
      newRows[rowIndex] = {
        ...newRows[rowIndex],
        [field]: value,
      };
    }
    setInspectionRows(newRows);
  };

  const handleRowDelete = (rowIndex) => {
    const newRows = [...inspectionRows];
    const deletedRow = newRows[rowIndex];
    if (deletedRow?.id && !deletedRow.isNew) {
      setDeletedInspectionIds((prev) => [...prev, deletedRow.id]);
    }
    newRows.splice(rowIndex, 1);
    setInspectionRows(newRows);
  };

  const fetchClientList = async () => {
    const list = await fetchQuery(`select * from clients where status = 1`);
    setClientList(list);
  };

  const fetchserviceRequestList = async () => {
    let query = `SELECT pa.* FROM poAcceptance pa JOIN quotation q ON pa.quotationId = q.id WHERE q.clientId =  ${inputStates?.clientId}`;
    const list = await fetchQuery(query);
    const verbalOption = { id: 0, poNumber: "Verbal" };
    setPoList([...(list || []), verbalOption]);
  };

  const fetchjobRegisterLast = async () => {
    try {
      const query = `select count(1) as count from jobRegister`;
      const result = await fetchQuery(query);
      return result[0]?.count || 0;
    } catch (error) {
      console.error("Error fetching jobRegister item count:", error);
      return 0;
    }
  };

  const fetchAllInspectionItems = async () => {
    try {
      const allServices = await fetchQuery(
        "SELECT id,subcategory, id AS equipmentId FROM inspectionItems"
      );
      setinspectionItemsList(allServices);
    } catch (error) {
      console.error("Error fetching all inspection subcategory:", error);
    }
  };

  const onSubmit = async () => {
    try {
      // 1. Delete removed inspection rows
      if (deletedInspectionIds?.length > 0) {
        const idList = deletedInspectionIds.map((id) => `'${id}'`).join(",");
        const deleteQuery = `DELETE FROM jobRegisterInspection WHERE id IN (${idList})`;
        await axiosWithToken.post(BASE_URL + "dynamic", { query: deleteQuery });

        // Delete associated IR records
        const deleteIRQuery = `DELETE FROM IR WHERE jobRegisterInspectionId IN (${idList})`;
        await axiosWithToken.post(BASE_URL + "dynamic", {
          query: deleteIRQuery,
        });

        // Delete cover letters records
        const deleteIRCoverQuery = `DELETE FROM IR_coverLetter WHERE jobRegisterId IN (${idList})`;
        await axiosWithToken.post(BASE_URL + "dynamic", {
          query: deleteIRCoverQuery,
        });
      }

      // 2. Save jobRegister (main form)
      const {
        id,
        contact,
        companyName,
        addressid,
        address,
        poNumberID,
        selectedAddressId,
        ...restInputStates
      } = inputStates;

      const jobPayload = {
        ...restInputStates,
        address: addressid,
        inspectionStartDate: inputStates.inspectionStartDate ? moment(inputStates.inspectionStartDate).format("YYYY-MM-DD") : null,
        inspectionEndDate: inputStates.inspectionEndDate ? moment(inputStates.inspectionEndDate).format("YYYY-MM-DD") : null,
      };

      let jobRegisterId = params.id;
      const jobUrl = BASE_URL + "jobRegister";
      let finalJobNumber = inputStates?.jobNumber;

      if (params.id == 0) {
        const res = await axiosWithToken.post(jobUrl, jobPayload);
        jobRegisterId = res?.data?.insertId;
        // fetch updated jobNumber from DB (trigger-updated)
        const query = `SELECT jobNumber FROM jobRegister WHERE id = ${jobRegisterId}`;
        const [jobData] = await fetchQuery(query);
        finalJobNumber = jobData?.jobNumber;
      } else {
        await axiosWithToken.patch(jobUrl + `/${id}`, jobPayload);
      }

      // 3. Process inspection rows
      const updatePromises = [];
      const irInsertPromises = [];

      for (let i = 0; i < inspectionRows.length; i++) {
        const row = inspectionRows[i];

        const inspectionPayload = {
          jobRegisterId,
          servicesNameId: row.servicesNameId,
          quantity: row.quantityUnit ? `${row.quantity || ""}#${row.quantityUnit}` : row.quantity || null,
          clientRequestFile: row.clientRequestFile || null,
          qapDrawings: row.qapDrawings || null,
          technicalDatasheet: row.technicalDatasheet || null,
          technicalSpecification: row.technicalSpecification || null,
          inspectionNumber: `${finalJobNumber?.replace(/AIPL\//i, '')}/${i + 1}`,
        };

        if (row.isNew || !row.id) {
          const res = await axiosWithToken.post(
            BASE_URL + "jobRegisterInspection",
            inspectionPayload
          );
          const insertedId = res?.data?.insertId;

          // Queue IR insert promise
          irInsertPromises.push(axiosWithToken.post(BASE_URL + "IR", {jobRegisterInspectionId: insertedId}));

          irInsertPromises.push(axiosWithToken.post(BASE_URL + "IR_coverLetter", {
              jobRegisterId: insertedId,
              mode: 2, // edit
            })
          );
        } else {
          const original = originalInspectionRows.find((r) => r.id == row.id);
          const hasChanged =
            original?.servicesNameId !== row.servicesNameId ||
            original?.quantity != row.quantity ||
            original?.clientRequestFile !== row.clientRequestFile ||
            original?.qapDrawings !== row.qapDrawings ||
            original?.technicalDatasheet !== row.technicalDatasheet ||
            original?.technicalSpecification !== row.technicalSpecification ||
            original?.inspectionNumber !== inspectionPayload.inspectionNumber;

          if (hasChanged) {
            updatePromises.push(
              axiosWithToken.patch(
                BASE_URL + `jobRegisterInspection/${row.id}`,
                inspectionPayload
              )
            );
          }
        }
      }

      // 4. Execute all IR inserts and inspection updates in parallel
      await Promise.all([...updatePromises, ...irInsertPromises]);

      toast.success(params.id == 0 ? "Job Created!" : "Job Updated!");
      if (params.id == 0) {
        setTimeout(() => navigate("/jobRegisterList"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.log("Submit Error:", error.message);
    }
  };

  useEffect(() => {
    const fetchPOWiseProductList = async () => {
      if (!inputStates.poNumberID) return;
      try {
        const query = `SELECT pd.id, pd.referenceId, pd.equipmentId, ii.subcategory FROM productDetails pd LEFT JOIN inspectionItems ii ON pd.equipmentId = ii.id WHERE pd.type = 3 AND pd.referenceId = '${inputStates.poNumberID}'`;
        const services = await fetchQuery(query);
        setinspectionItemsList(services || []);
      } catch (e) {
        console.error("Error fetching PO-wise product list:", e);
      }
    };

    if (inputStates.poNumber === "Verbal") {
      fetchAllInspectionItems();
    } else {
      if (inputStates.poNumber) {
        fetchAllInspectionItems();
        // add all subcategory
        // fetchPOWiseProductList();
      }
    }
  }, [inputStates.poNumber, inputStates.poNumberID]);

  useEffect(() => {
    fetchClientList();
  }, []);

  useEffect(() => {
    const selectedState = statesList.find(
      (s) => s.label === inputStates.state
    );
    if (selectedState?.district) {
      setDistrictOptions(selectedState.district);
    } else {
      setDistrictOptions([]);
    }
  }, [inputStates.state]);

  // Fetch client addresses when client changes
  const fetchClientData = async () => {
    const currentClient = clientList.find((i) => i.id == inputStates.clientId);
    if (!currentClient) return;

    try {
      // Fetch all addresses for the client (only billing addresses)
      const addresses = await fetchAddresses(currentClient?.address);

      if (addresses.length === 1) {
        // Single address - auto-populate
        const [currentAddress] = addresses;
        setInputStates((prev) => ({
          ...prev,
          address: currentAddress?.address || "",
          addressid: currentAddress?.id || "",
        }));
        setShowAddressSelection(false);
        setAvailableAddresses([]);
      } else if (addresses.length > 1) {
        // Multiple addresses - show selection
        const formattedAddresses = addresses.map((addr) => ({
          id: addr.id,
          address: addr.address,
          displayAddress: `${addr.address?.substring(0, 50)}${addr.address?.length > 50 ? "..." : ""
            }`,
        }));

        setAvailableAddresses(formattedAddresses);
        setShowAddressSelection(true);

        // Don't set address yet - wait for user selection
        setInputStates((prev) => ({
          ...prev,
          address: "",
          addressid: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  // Handle address selection
  useEffect(() => {
    if (
      inputStates?.selectedAddressId &&
      availableAddresses.length > 0
    ) {
      const selectedAddress = availableAddresses.find(
        (addr) => addr.id === inputStates.selectedAddressId
      );
      if (selectedAddress) {
        setInputStates((prev) => ({
          ...prev,
          address: selectedAddress.address,
          addressid: selectedAddress.id,
        }));
      }
    }
  }, [inputStates?.selectedAddressId, availableAddresses]);

  useEffect(() => {
    if (inputStates?.clientId && params.id == 0) {
      fetchClientData();
    }
  }, [inputStates.clientId, clientList]);

  useEffect(() => {
    if (inputStates?.clientId) {
      fetchserviceRequestList();
    }
  }, [inputStates.clientId]);

  const fetchExistingInspectionRows = async (jobRegisterId) => {
    try {
      const query = `SELECT jri.*, ii.subcategory FROM jobRegisterInspection jri LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id WHERE jri.jobRegisterId = ${jobRegisterId}`;
      const result = await fetchQuery(query);

      // Ensure all fields have default values if not present
      const processedResult = result.map(row => {
        const [quantity = "", quantityUnit = ""] =
          (row.quantity || "").split("#");
        return {
          ...row,
          quantity,
          quantityUnit,
          clientRequestFile: row.clientRequestFile || "",
          qapDrawings: row.qapDrawings || "",
          technicalDatasheet: row.technicalDatasheet || "",
          technicalSpecification: row.technicalSpecification || "",
        };
      });

      // Set to both inspectionRows and original copy for change tracking
      setInspectionRows(processedResult);
      setOriginalInspectionRows(processedResult);
    } catch (error) {
      console.error("Error fetching jobRegisterInspection rows:", error);
    }
  };

  useEffect(() => {
    const generatejobNumberNo = async () => {
      const count = await fetchjobRegisterLast();
      const newCount = count + 1;
      const jobNumberCreate = `${reportLetter}/${newCount}`;
      updateInputObject("jobNumber", jobNumberCreate);
    };
    if (params.id == 0) {
      generatejobNumberNo();
    }
    if (params.id != 0) {
      // fetchJobRegisterDetails();
      fetchExistingInspectionRows(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    if (params.id != 0) {
      fetchJobRegisterDetails();
    }
  }, [params.id, poList]);

  useEffect(() => {
    if (
      params.id == 0 &&
      navState?.poclientId
    ) {
      setInputStates(prev => ({
        ...prev,
        clientId: navState.poclientId,
        poNumber: navState.poAcceptancepoNumber,
        poNumberID: navState.poNumberID,
      }));
    }
  }, [params.id, navState]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Job Request" : `Update Job Request`}
      </Text>
      <br />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <Autocomplete
          size="small"
          options={clientList}
          getOptionLabel={(option) => option.companyName + (option.type ? ` (${clienTypes.find(c => c.value == option.type)?.short || ""})` : "")}
          value={
            clientList.find((item) => item.id == inputStates.clientId) || null
          }
          onChange={(e, newValue) => {
            updateInputObject("clientId", newValue?.id || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Paying Party" fullWidth />
          )}
          disabled={params.id != 0 || (params.id == 0 && navState?.poAcceptancepoNumber)}
        />

        {/* Show address selection dropdown if multiple addresses available */}
        {showAddressSelection && availableAddresses.length > 1 && params.id == 0 ? (
          <Autocomplete
            size="small"
            options={availableAddresses}
            getOptionLabel={(option) => option.displayAddress || ""}
            value={
              availableAddresses.find((item) => item.id == inputStates.selectedAddressId) || null
            }
            onChange={(e, newValue) => {
              updateInputObject("selectedAddressId", newValue?.id || "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Address" fullWidth />
            )}
          />
        ) : (
          <TextFields
            disabled
            id="job"
            label="Address"
            value={inputStates.address || ""}
            onChange={(e) => updateInputObject("address", e.target.value)}
          />
        )}
        <TextFields
          id="job"
          label="Job Number"
          value={inputStates.jobNumber || ""}
          onChange={(e) => updateInputObject("jobNumber", e.target.value)}
          disabled
        />
        <DateInput
          id="from-date"
          label="Inspection Start Date"
          value={inputStates.inspectionStartDate || null}
          onChange={(date) => {
            const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
            updateInputObject("inspectionStartDate", formattedDate);
          }}
        />
        <DateInput
          id="from-date"
          label="Inspection End Date"
          value={inputStates.inspectionEndDate || null}
          onChange={(date) => {
            const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
            updateInputObject("inspectionEndDate", formattedDate);
          }}
        />
        <TextFields
          id="inspectionLocation"
          label="Inspection location / Address"
          value={inputStates.inspectionLocation || ""}
          onChange={(e) =>
            updateInputObject("inspectionLocation", e.target.value)
          }
        />
        <Autocomplete
          options={statesList}
          getOptionLabel={(option) => option.label || ""}
          value={
            statesList.find((item) => item.label == inputStates.state) || null
          }
          onChange={(e, newValue) => {
            updateInputObject("state", newValue?.label || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select State" fullWidth />
          )}
          fullWidth
          size="small"
        // disabled={params.id != 0}
        />
        <Autocomplete
          options={districtOptions}
          getOptionLabel={(option) => option.city || ""}
          value={
            districtOptions.find((item) => item.city == inputStates.location) || null
          }
          onChange={(e, newValue) => {
            updateInputObject("location", newValue?.city || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select Location" fullWidth />
          )}
          fullWidth
          size="small"
        // disabled={params.id != 0}
        />
        <Autocomplete
          options={poList}
          getOptionLabel={(option) => option.poNumber || ""}
          value={
            poList.find((item) => item.poNumber == inputStates.poNumber) || null
          }
          onChange={(e, newValue) => {
            updateInputObject("poNumber", newValue?.poNumber || "");
            updateInputObject("poNumberID", newValue?.id || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Po Number" fullWidth />
          )}
          fullWidth
          size="small"
          disabled={params.id != 0 || (params.id == 0 && navState?.poAcceptancepoNumber)}
        />
        <br />
      </div>

      <br />
      <div className="flex justify-end mb-5">
        <AddButton
          id="btn-add-outline"
          label="Add Service Request"
          icon={<AddIcon fontSize="small" />}
          onClick={() => addRangeRow()}
        />
      </div>

      <div style={{ width: "100%", overflow: "auto" }}>
        <ClassicTable>
          <Table sx={{ minWidth: 900 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {inspectionservicesTable.map((column) => (
                  <TableCell key={column.field}>{column.headerName}</TableCell>
                ))}
                {(permissions.delete || permissions.allAccess) && (<TableCell>Actions</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {inspectionRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ width: "5%" }}>
                    <div className="flex gap-4 items-center">
                      {index + 1}
                    </div>
                  </TableCell>
                  <TableCell style={{ width: "25%" }}>
                    <Autocomplete
                      size="small"
                      options={inspectionItemsList}
                      getOptionLabel={(option) => option.subcategory || ""}
                      value={
                        inspectionItemsList.find(
                          (item) => item.equipmentId == row?.servicesNameId
                        ) || null
                      }
                      onChange={(e, newValue) =>
                        updateCellValue(
                          index,
                          "servicesNameId",
                          newValue?.equipmentId || ""
                        )
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Service" />
                      )}
                    />
                  </TableCell>
                  <TableCell style={{ display: "flex", gap: "6px", minWidth: 260 }}>
                    <TextFields
                      size="small"
                      value={row.quantity || ""}
                      onChange={(e) =>
                        updateCellValue(index, "quantity", parseInt(e.target.value) || "")
                      }
                    />
                    <Select
                      sx={{ width: "80%" }}
                      size="small"
                      value={row.quantityUnit || ""}
                      onChange={(e) => updateCellValue(index, "quantityUnit", e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {quantityUnits.map((unit) => (
                        <MenuItem key={unit} value={unit}>
                          {unit}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell style={{ width: "15%" }}>
                    <FileUploadComponent
                      fileUploadResponse={row.clientRequestFile}
                      setFileUploadResponse={(fileUrl) =>
                        updateCellValue(index, "clientRequestFile", fileUrl)
                      }
                      label="Upload"
                    />
                  </TableCell>
                  <TableCell style={{ width: "15%" }}>
                    <FileUploadComponent
                      fileUploadResponse={row.qapDrawings}
                      setFileUploadResponse={(fileUrl) =>
                        updateCellValue(index, "qapDrawings", fileUrl)
                      }
                      label="Upload"
                    />
                  </TableCell>
                  <TableCell style={{ width: "15%" }}>
                    <FileUploadComponent
                      fileUploadResponse={row.technicalDatasheet}
                      setFileUploadResponse={(fileUrl) =>
                        updateCellValue(index, "technicalDatasheet", fileUrl)
                      }
                      label="Upload"
                    />
                  </TableCell>
                  <TableCell style={{ width: "15%" }}>
                    <FileUploadComponent
                      fileUploadResponse={row.technicalSpecification}
                      setFileUploadResponse={(fileUrl) =>
                        updateCellValue(index, "technicalSpecification", fileUrl)
                      }
                      label="Upload"
                    />
                  </TableCell>
                  {(permissions.delete || permissions.allAccess) && (
                    <TableCell style={{ width: "5%" }}>
                      <DeleteIcon
                        style={{ color: "#dc3545", cursor: "pointer" }}
                        onClick={() => handleRowDelete(index)}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ClassicTable>
      </div>

      <br />
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditJobRegister;
